// Core React Imports
import React from "react";

// Local Imports
import { DivRow } from "../../../styles/SharedStyles";

const WidgetRequiredLabel = ({ children, isRequired = false }) => {
  return (
    <DivRow style={{ width: "100%", gap: "0.2rem" }}>
      {children}
      {isRequired && <span style={{ color: "#FF0000", fontSize: "1.2rem" }}>*</span>}
    </DivRow>
  );
};

export default WidgetRequiredLabel;
